import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { ScrollArrows } from 'src/domains/sportsbook/webview/components/scrollArrows/ScrollArrows';
import { NextRacesState } from 'src/domains/sportsbook/webview/components/nextRaces/NextRaces.state';
import { useCommon } from 'src/domains/common/Common';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { RacingCardsSwiper, RaceSliderWrapper, RacesSliderInfo, RaceSwiperWrapper } from './NextRacesSlider.style';
import { RaceSliderItem } from 'src/domains/sportsbook/webview/components/racesSlider/RaceSliderItem';
import { NextRacesSliderListLoader } from 'src/domains/sportsbook/webview/components/nextRaces/racesSlider/NextRacesSliderListLoader';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { InfoIconUnifiedWrapper } from 'src/domains/sportsbook/webview/components/sportEventsListNew/EventsTableMobX.style';
import { InfoIconUnified } from 'src/domains/layouts/shared/assets/icons/InfoIconUnified';

export const numberOfItemsInRaceBox = 3;

interface NextRacesSliderPropsType {
    nextRacesState: NextRacesState;
}

export const NextRacesSliderList = observer('NextRacesSliderList', (props: NextRacesSliderPropsType) => {
    const common = useCommon();
    const {
        componentVariants: { sportsbookVariant },
        unifiedSportEventsTable,
    } = ConfigComponents.get(common).unifiedComponentConfig;
    const env = EnvironmentState.get(common);
    const { nextRacesState } = props;
    const { sliderState, eventsCount, racingEventsListToDisplayReady, isLoadingEventsCollectionEarly } = nextRacesState;

    const detectFeatures = env.modernizrDetect;
    const isTouchEventsAvailable = detectFeatures !== null && detectFeatures.touchevents === true;

    const {
        setRefSlider,
        setNextSlide,
        setPreviousSlide,
        calcShift,
        onTouchEnd,
        onTouchMove,
        onTouchStart,
        isLeftArrowActive,
        isRightArrowActive,
        isNotPossibleToSlide,
    } = sliderState;

    if (isLoadingEventsCollectionEarly) {
        return <NextRacesSliderListLoader />;
    }

    if (eventsCount === 0) {
        return (
            <RacesSliderInfo variant={sportsbookVariant}>
                {unifiedSportEventsTable ? (
                    <InfoIconUnifiedWrapper>
                        <InfoIconUnified />
                    </InfoIconUnifiedWrapper>
                ) : null}
                <I18n
                    langKey='races-slider.no-found-races'
                    defaultText="Sorry, we haven't found any races with such criteria."
                />
            </RacesSliderInfo>
        );
    }

    return (
        <RaceSliderWrapper
            variant={sportsbookVariant}
            key='races-slider-races'
        >
            <RaceSwiperWrapper variant={sportsbookVariant}>
                <RacingCardsSwiper
                    key='slider-swiper'
                    ref={setRefSlider}
                    inProgress={false}
                    calcShift={calcShift}
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                >
                    {racingEventsListToDisplayReady.map((eventModel) => {
                        return (
                            <RaceSliderItem
                                key={eventModel.id2.key}
                                data-test-event-id={eventModel.id2.toOldId()}
                                eventId={eventModel.id2}
                            />
                        );
                    })}
                </RacingCardsSwiper>

                {isTouchEventsAvailable || isNotPossibleToSlide ? null : (
                    <ScrollArrows
                        key='races-slider-pagination'
                        goLeftAvailable={isLeftArrowActive}
                        goRightAvailable={isRightArrowActive}
                        onLeft={setPreviousSlide}
                        onRight={setNextSlide}
                    />
                )}
            </RaceSwiperWrapper>
        </RaceSliderWrapper>
    );
});
